import { initialApiActionState } from 'api/createApiClient';
import useBranch from 'client/hooks/useBranch';

export default function useApiState(apiActionSetting, opts = {}) {
  apiActionSetting =
    typeof apiActionSetting === 'string' ? { action: apiActionSetting } : apiActionSetting;

  const { apiState } = useBranch({
    apiState: [
      opts.statePath || 'apiState',
      apiActionSetting.action,
      apiActionSetting.queryId ? `${apiActionSetting.queryId}` : 'default',
    ],
  });

  return apiState || initialApiActionState;
}
